import { PropagateLoader } from 'react-spinners';

export const Loading = () => (
  <div
    style={{
      width: '100%',
      position: 'relative',
      height: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <PropagateLoader size={15} color="#38abd8" loading={true} />
  </div>
);
